import { Region } from "@smash-sdk/core";

export type DataCenterRegions = 'FR' | 'GB' | 'IE' | 'DE' | 'CA' | 'US_EAST' | 'US_WEST' | 'UE';


function isUsEastCountry(countryCode, region): boolean {
    return countryCode === 'US' && region.match(/^us-east/);
}

function isUsWestCountry(countryCode, region): boolean {
    return countryCode === 'US' && region.match(/^us-west/);
}

function isCountrySupported(countryCode, supportedCountries, region): boolean {
    return !!supportedCountries.find(supportedCountry => supportedCountry.countryCode === countryCode && supportedCountry.dataCenters.includes(region));
}

function isEuropeanCountry(countryCode, region): boolean {
    const euRegions = ['eu-west-1', 'eu-west-2', 'eu-west-3', 'eu-central-1']
    const euCountryCode = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'GR', 'CH'];
    return !!euRegions.find(euRegion => euRegion === region) && !!euCountryCode.find(euCountryCode => euCountryCode === countryCode);
}

export function matchDataCenter(userCountryCode: string, region: Region): { supportedCountry: boolean, value: string } {
    const supportedCountries = [
        {
            countryCode: 'IE',
            dataCenters: ['eu-west-1']
        },
        {
            countryCode: 'GB',
            dataCenters: ['eu-west-2']
        },
        {
            countryCode: 'FR',
            dataCenters: ['eu-west-3']
        },
        {
            countryCode: 'DE',
            dataCenters: ['eu-central-1']
        },
        {
            countryCode: 'CA',
            dataCenters: ['ca-central-1']
        },
        {
            countryCode: 'US',
            dataCenters: ['us-west-1', 'us-west-2', 'us-east-1', 'us-east-2']
        },
    ];

    // User is in the US need to process East or West
    if (isUsEastCountry(userCountryCode, region)) {
        return { supportedCountry: true, value: 'US_EAST' };
    }
    if (isUsWestCountry(userCountryCode, region)) {
        return { supportedCountry: true, value: 'US_WEST' };
    }
    // is user in supported countries ?
    if (isCountrySupported(userCountryCode, supportedCountries, region)) {
        const { countryCode } = supportedCountries.find(supportedCountry => supportedCountry.countryCode === userCountryCode && supportedCountry.dataCenters.includes(region))
        return { supportedCountry: true, value: countryCode };
    }
    // is user in europe ?
    if (isEuropeanCountry(userCountryCode, region)) {
        return { supportedCountry: false, value: 'UE' };
    }

    // not supported
    return { supportedCountry: false, value: null };

}



